import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InstantRatesManagerComponent } from './pages/instant-rates-manager/instant-rates-manager.component';
import { RateListingsComponent } from './pages/rate-listings/rate-listings.component';
import { authGuard } from 'src/app/services/auth/guard/auth.guard';
import { BulkCreateRateComponent } from './pages/bulk-create-rate/bulk-create-rate.component';
import { ProviderLocationsComponent } from './pages/provider-locations/provider-locations.component';
import { AppliedTermsComponent } from './pages/applied-terms/applied-terms.component';
import { BulkUploadPreviewComponent } from './components/bulk-upload-preview/bulk-upload-preview.component';

const routes: Routes = [
  {
    path: '',
    component: InstantRatesManagerComponent,
    canActivate: [
      authGuard,
    ],
    data: {
      allowedModes: [
        'provider',
      ],
    },
  },
  {
    path: 'rates',
    component: RateListingsComponent,
    canActivate: [
      authGuard,
    ],
    data: {
      allowedModes: [
        'provider',
      ],
    },
  },
  {
    path: 'bulk-upload-preview',
    component: BulkUploadPreviewComponent,
    canActivate: [
      authGuard,
    ],
    data: {
      allowedModes: [
        'provider',
      ],
    },
  },
  {
    path: 'location-settings',
    component: ProviderLocationsComponent,
    canActivate: [
      authGuard,
    ],
    data: {
      allowedModes: [
        'provider',
      ],
      breadcrumb: 'Location Settings',
    },
  },
  {
    path: 'provider-locations',
    redirectTo: 'location-settings',
    pathMatch: 'full',
  },
  {
    path: 'applied-terms',
    component: AppliedTermsComponent,
    canActivate: [
      authGuard,
    ],
    data: {
      allowedModes: [
        'provider',
      ],
    },
  },
  {
    path: 'applied-terms/category/:categoryId',
    component: AppliedTermsComponent,
    canActivate: [
      authGuard,
    ],
    data: {
      allowedModes: [
        'provider',
      ],
    },
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})
export class RateManagerRoutingModule {}
